import React, { useRef, useState } from "react";
import { Upload, Link2, Loader2, X } from "lucide-react";
import { uploadImage, resolveImg } from "../../services/api";
import { Input } from "../ui/input";
import { useToast } from "../../hooks/use-toast";

// Single image field: preview + upload file OR paste URL
const ImageUploader = ({ value, onChange, label = "Image" }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const { toast } = useToast();

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const res = await uploadImage(file);
      onChange(res.url);
      toast({ title: "Image uploaded" });
    } catch (err) {
      toast({ title: "Upload failed", variant: "destructive" });
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      {label && <div className="text-sm font-medium text-neutral-700 mb-1.5">{label}</div>}
      <div className="flex gap-3 items-start">
        <div className="w-20 h-20 rounded-lg overflow-hidden bg-neutral-100 border border-neutral-200 flex-shrink-0 relative">
          {value ? (
            <>
              <img src={resolveImg(value)} alt="" className="w-full h-full object-cover" />
              <button type="button" onClick={() => onChange("")} className="absolute top-0.5 right-0.5 w-5 h-5 bg-black/60 text-white rounded-full flex items-center justify-center"><X className="w-3 h-3" /></button>
            </>
          ) : (
            <div className="w-full h-full flex items-center justify-center text-neutral-300"><Upload className="w-6 h-6" /></div>
          )}
        </div>
        <div className="flex-1 space-y-2">
          <div className="flex items-center gap-2">
            <Link2 className="w-4 h-4 text-neutral-400" />
            <Input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="Paste image URL" className="h-9" />
          </div>
          <button type="button" onClick={() => inputRef.current?.click()} disabled={uploading}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#C9A227] hover:text-[#A6841B]">
            {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Upload from computer
          </button>
          <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} />
        </div>
      </div>
    </div>
  );
};

export default ImageUploader;
